
import { configureStore } from '@reduxjs/toolkit'
import authReducer from './authSlice'
import settingsReducer from './settingsSlice'
import produitReducer from './produitSlice'
import platReducer from './platSlice'
import venteReducer from './venteSlice'




const store = configureStore({
    reducer: {
        auth: authReducer,
        settings: settingsReducer,
        produit: produitReducer,
        plat: platReducer,
        vente: venteReducer
    }
})

export default store

